<template>
	<div>
		<v-layout wrap pa-4>
			<v-flex xs12 title>
				¿Desea eliminar el detalle con cuenta {{ name }}
				perteneciente al asiento {{ seatName }}?
			</v-flex>
		</v-layout>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="loading"
				success-text="Eliminar"
				@cancel-button-clicked="$emit('close-modal')"
				@accept-button-clicked="$emit('on-delete')"
			>
			</modal-sidebar-button>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'journal-detail-delete-form',
		props: {
			loading: {
				default: false,
				type: Boolean,
			},
			name: String,
			seatName: String,
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/journal/journal-detail-delete-form.vue